// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import ConstraintViolationsByOrder from './constraintViolationsByOrder';
import React from 'react';

function ConstraintViolationsByOrderPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-constraint-violations-by-order-page">
            <ConstraintViolationsByOrder />
        </AuthenticatedPage>
    );

}
ConstraintViolationsByOrderPage.displayNAme = 'ConstraintViolationsByOrderPage';

export default ConstraintViolationsByOrderPage;
